'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const shiftDateBy = (shifts = {}, date = new Date()) => {
    const { days = 0, hours = 0, minutes = 0, seconds = 0 } = shifts;
    return new Date(date.getTime() +
        days * 86400000 + // 1 day = 86 400 000 ms
        hours * 3600000 + // 1 hour = 3 600 000 ms
        minutes * 60000 + // 1 minute = 60 000 ms
        seconds * 1000);
};

exports.shiftDateBy = shiftDateBy;
//# sourceMappingURL=shift-date-by.js.map
